import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from "@angular/router";

export class CustomReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<
    string,
    { handle: DetachedRouteHandle; scrollTop: number }
  >();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return !!route.routeConfig && !!route.routeConfig.data?.reuse;
  }

  store(
    route: ActivatedRouteSnapshot,
    handle: DetachedRouteHandle | null,
  ): void {
    if (handle && route.routeConfig) {
      const scrollContainer = document.querySelector(
        ".justup-page-main-content",
      ) as HTMLElement;
      const scrollTop = scrollContainer?.scrollTop || 0;

      this.storedRoutes.set(route.routeConfig.path!, { handle, scrollTop });
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return (
      !!route.routeConfig && this.storedRoutes.has(route.routeConfig.path!)
    );
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const stored = route.routeConfig
      ? this.storedRoutes.get(route.routeConfig.path!)
      : null;

    if (stored) {
      setTimeout(() => {
        const scrollContainer = document.querySelector(
          ".justup-page-main-content",
        ) as HTMLElement;
        if (scrollContainer) {
          scrollContainer.scrollTo({ top: stored.scrollTop });
        }
      }, 0);

      return stored.handle;
    }

    return null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}
